module.exports = __webpack_public_path__ + "static/media/am3.ade671ab.webp";